module.exports = __webpack_public_path__ + "img/b5 عمودی.1b624430.jpg";